





















































































import { Consent } from "@/api/open-api";
import { QTable } from "quasar";
import Vue from "vue";

interface Data {
  table: QTable;
}

export default Vue.extend({
  name: "c-daily-customer-consent-aggregate-consents",
  props: {
    consents: {
      type: Array as () => Consent[]
    }
  },

  data(): Data {
    return {
      table: {
        columns: [
          {
            name: "groupDescription",
            field: "groupDescription",
            label: "Gruppo"
          },
          {
            name: "description",
            field: "description",
            label: "Consenso"
          },
          {
            name: "responseDescription",
            field: (row: Consent) => {
              if (row.systemFieldType === "mandate") {
                return row.mandateCompanyDescription;
              }

              return row.responseDescription;
            },
            label: "Risposta"
          },
          {
            name: "statusCode",
            field: "statusCode",
            label: "Stato"
          }
        ]
      } as QTable
    };
  },

  methods: {
    getRowKey(row: Consent) {
      return JSON.stringify(row);
    }
  }
});
